import { useEffect } from "react";
import { useConfiguration } from "@/contexts/ConfigProvider";
import { DatadogRumService } from "@/services/datadog-rum.service";
import { syncCurrentUserToDatadogRum } from "@/stores/auth-store";

/**
 * Datadog RUM Initializer Component
 *
 * Initializes Datadog RUM using runtime configuration.
 * This component is rendered within the router context to ensure config is available.
 * Uses the DatadogRumService singleton to prevent double initialization.
 *
 * Auth usually resolves before the runtime config does, and `addUser` is a
 * no-op until RUM is initialized, so re-send the current user once init is done.
 */
export function DatadogInitializer() {
	const config = useConfiguration();

	useEffect(() => {
		if (!config) {
			console.debug("🐶 Datadog RUM: Waiting for configuration...");
			return;
		}

		// Initialize Datadog RUM with runtime config
		DatadogRumService.initialize(config)
			.then(() => {
				if (DatadogRumService.isInitialized()) {
					syncCurrentUserToDatadogRum();
				}
			})
			.catch((error) => {
				console.warn("🐶 Datadog RUM: Initialization error:", error);
				// Non-blocking - app continues without Datadog
			});
	}, [config]);

	return null;
}
